import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "../../data/api/api";

export const createSapeagleOrder = createAsyncThunk(
    "sapeagleOrder/create",
    async (formData, { rejectWithValue}) =>{
        try{
            const response = await API.post("/sapeagleorder/create", formData);
            return response.data;

        }catch(error){
            return rejectWithValue(error.response.data);
        }
    }
)


const sapeagleOrderSlice = createSlice({
    name : "sapeagleOrder",
    initialState: {
    loading: false,
    success: false,
    error: null,
    orderData: null,
  },

  reducers:{
    resetOrderState: (state)=>{
        state.loading = false;
        state.success = false;
        state.error = null;
        state.orderData = null;
    }
  },
  extraReducers: (builder) =>{
    builder.addCase(createSapeagleOrder.pending, (state)=>{
        state.loading = true;
        state.success = false;
        state.error = null;
    })
    .addCase(createSapeagleOrder.fulfilled, (state, action)=>{
        state.loading = false;
        state.success = true;
        state.orderData = action.payload;
    })
    .addCase(createSapeagleOrder.rejected, (state, action)=>{
        state.loading = false;
        state.success = false;
        state.error = action.payload;
    })
  }
})

export const {resetOrderState} = sapeagleOrderSlice.actions;
export default sapeagleOrderSlice.reducer;